<script lang="ts">
	import { goto } from '$app/navigation';
	import WidgetButton from './WidgetButton.svelte';

	interface Props {
		editable: boolean;
		href: string;
		children?: import('svelte').Snippet;
	}

	let { editable, href, children }: Props = $props();
</script>

<div class="flex justify-end items-start gap-2">
	<div class="text-pretty truncate">
		{@render children?.()}
	</div>
	{#if editable}
		<WidgetButton
			onclick={() => goto(href, { replaceState: true })}
			icon="edit"
			height="h-5 w-5"
			iconSizeClasses="w-3.5 h-3.5"
			className="mt-0.5"
		/>
	{/if}
</div>
